import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'giftCardID',
})
export class GiftCardIDPipe implements PipeTransform {
    transform(id: string): string {
        if (id && id.length > 0) {
            id = id.match(new RegExp('.{1,4}', 'g')).join('-');
            return id.toUpperCase();
        }

        return id;
    }
}
